package ir.hosen.resume.styles

import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.margin
import com.varabyte.kobweb.silk.style.CssStyle
import com.varabyte.kobweb.silk.style.selectors.hover
import org.jetbrains.compose.web.css.px

val FABStyle = CssStyle {
    base {
        Modifier.margin(bottom = 0.px)
    }
    hover {
        Modifier.margin(bottom = 4.px)
    }
}